import React, { useId } from 'react';
import { Box, FormLabel, TextField } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { colors } from '../../theme/colors';

// Onboarding Figma input / field: 153:2761 and 166:960. Keep the app's Play font.
export default function AuthTextField({ component: Input = TextField, label, hideLabel = false,
  id, error, helperText, placeholder = label, ...props }) {
  const generatedId = useId();
  const inputId = id || generatedId;
  return <Box sx={{ width: '100%' }}>
    <FormLabel htmlFor={inputId} sx={hideLabel ? visuallyHidden : {
      display: 'block', mb: 1.5, color: colors.Grey[900], fontSize: 14, lineHeight: '20px', fontWeight: 500,
    }}>{label}</FormLabel>
    <Input {...props} id={inputId} fullWidth size="small" variant="outlined" placeholder={placeholder}
      error={Boolean(error)} helperText={helperText}
      FormHelperTextProps={{ role: error ? 'alert' : undefined }}
      sx={{
        '& .MuiOutlinedInput-root': {
          minHeight: 36, px: '12px', borderRadius: hideLabel ? '22px' : '26px',
          bgcolor: 'rgba(230, 230, 230, 0.5)', fontSize: 14, lineHeight: '20px',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: colors.Grey[300] },
          '&.Mui-focused': { outline: `2px solid ${colors.Primary[800]}`, outlineOffset: 2 },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: colors.Primary[800], borderWidth: 1 },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: colors.Error[600] },
          '&.Mui-error.Mui-focused': { outlineColor: colors.Error[600] },
        },
        '& .MuiOutlinedInput-input': { boxSizing: 'border-box', height: 36, py: '8px', px: 0 },
        '& .MuiFormHelperText-root': { mx: 1.5, mt: 1 },
      }} />
  </Box>;
}
